import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { EdiMailBox } from '../../Models/Models/Company/EdiMailBox';

declare var IS_RUNNING_IN_APP_POOL;

export class EdiMailBoxClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<EdiMailBox>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/EdiMailBox/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<EdiMailBox>, any>(url, data);
  }
}

